/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const RepeatRegularV6 = (props) => (
  <Icon {...props} name="Repeat Regular V6">
    <path d="M5.5 4h4.472v1.75a.75.75 0 0 0 1.28.53l2.5-2.5a.75.75 0 0 0 0-1.061l-2.5-2.5a.75.75 0 0 0-1.28.53v1.75H5.5a5.49 5.49 0 0 0-5.5 5.5.75.75 0 0 0 1.5 0c0-2.206 1.794-4 4-4zm9.75 3.25a.75.75 0 0 0-.75.75c0 2.206-1.794 4-4 4H6v-1.75a.75.75 0 0 0-1.281-.531l-2.5 2.5a.75.75 0 0 0 0 1.061l2.5 2.5A.75.75 0 0 0 6 15.251v-1.75h4.5c3.033 0 5.5-2.468 5.5-5.5a.75.75 0 0 0-.75-.75z" />
  </Icon>
);

export default RepeatRegularV6;
